module.exports = __webpack_public_path__ + "img/20220219_072402.7a920957.jpg";